import { useProjectStore } from '@pinia/project';
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import useSubscribeNotifications from './project/useSubscribeProjects';
import useImpersonation from './user/useImpersonation';

export default async ({
  token,
  expiresAt,
  onRefreshTokenError,
}: {
  token?: string;
  expiresAt?: string;
  onRefreshTokenError?: () => void;
}) => {
  const sessionStore = useSessionStore();

  const { handleImpersonation } = useImpersonation({ expiresAt, token });

  sessionStore.initCompleted = false;

  await sessionStore.startRefreshToken(onRefreshTokenError);
  await sessionStore.loadMainUser();
  await handleImpersonation();

  const projectStore = useProjectStore();
  const { subscribeProjects } = useSubscribeNotifications();

  if (sessionStore.isLoggedIn) {
    subscribeProjects();
    await projectStore.reloadProjects();
  }

  sessionStore.initCompleted = true;
};
